export default "__VITE_ASSET__XxWofWTw__"